// src/services/admin/settingTypes.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const adminSettingTypesApi = createApi({
  reducerPath: "adminSettingTypesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/admin/setting-types`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["AdminSettingTypes"],
  endpoints: (builder) => ({
    // GET /api/admin/setting-types?page=&limit=&search=&active=
    getSettingTypes: builder.query({
      query: (args = {}) => {
        const { page, limit, search, active } = args || {};
        const params = {};
        if (page !== undefined && page !== null) params.page = page;
        if (limit !== undefined && limit !== null) params.limit = limit;
        if (search) params.search = search;
        if (active !== undefined && active !== null) params.active = active; // optional
        return { url: "", params };
      },
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({
                type: "AdminSettingTypes",
                id,
              })),
              { type: "AdminSettingTypes", id: "PARTIAL-LIST" },
            ]
          : [{ type: "AdminSettingTypes", id: "PARTIAL-LIST" }],
    }),

    // GET /api/admin/setting-types/:id
    getSettingTypeById: builder.query({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: "AdminSettingTypes", id }],
    }),

    // POST /api/admin/setting-types
    createSettingType: builder.mutation({
      query: (payload) => ({
        url: "/",
        method: "POST",
        body: payload, // { name, code, description, active? }
      }),
      invalidatesTags: [{ type: "AdminSettingTypes", id: "PARTIAL-LIST" }],
    }),

    // PUT /api/admin/setting-types/:id
    updateSettingType: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `/${id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "AdminSettingTypes", id },
        { type: "AdminSettingTypes", id: "PARTIAL-LIST" },
      ],
    }),

    // DELETE /api/admin/setting-types/:id
    deleteSettingType: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "AdminSettingTypes", id },
        { type: "AdminSettingTypes", id: "PARTIAL-LIST" },
      ],
    }),
  }),
});

export const {
  useGetSettingTypesQuery,
  useGetSettingTypeByIdQuery,
  useLazyGetSettingTypeByIdQuery,
  useCreateSettingTypeMutation,
  useUpdateSettingTypeMutation,
  useDeleteSettingTypeMutation,
} = adminSettingTypesApi;

export default adminSettingTypesApi;
export { adminSettingTypesApi };
